import React from 'react';
import { observer } from 'mobx-react';
import { config } from '../../config';

// Helpers
import { checkValidity } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Dependencies
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { FeatureFlag } from "react-launch-darkly";

// Components
import PhotoUpload from '../Modules/PhotoUpload';
import Password from '../Common/Password';

const UserSettings = observer(class UserSettings extends React.Component {
  constructor() {
    super();
    this.handleTabs = this.handleTabs.bind(this);
    this.handleInput = this.handleInput.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handlePhotoSubmit = this.handlePhotoSubmit.bind(this);
    this.handlePasswordSubmit = this.handlePasswordSubmit.bind(this);
    this.handleSchedulingSubmit = this.handleSchedulingSubmit.bind(this);
    this.resetPhoto = this.resetPhoto.bind(this);
    this.complete = this.complete.bind(this);
    this.renderScheduleTab = this.renderScheduleTab.bind(this);
    this.renderNoScheduleTab = this.renderNoScheduleTab.bind(this);
  }

  componentWillMount() {
    const { ScheduleStore, SessionStore } = this.props.store;

    this.state = {
      attachment: [],
      activeTab: 1,
      existingImage: [],
      oldImage: [],
      proctorTypes: [],
      proctorTypesInvalid: false
    }

    SessionStore.getProfile();
    this.getUserSettings();
    SessionStore.getProctorTypes();

    if(SessionStore.smarterscheduling) {
      ScheduleStore.getScheduleAccount();
    }
  }

  handleTabs(index) {
    this.setState({
      activeTab: index + 1,
    })
  }

  getUserSettings() {
    this.props.store.SettingsStore.getUserSettings(this);
  }

  handleInput(e, name) {
    let data = null;
    let value = null;

    if(name === 'phone') {
      value = e;
    } else {
      value = e.target.value;
    }

    // Make sure boolean values are boolean
    if(value === 'true') {
      if(e.target.checked) {
        value = true;
      } else {
        value = false;
      }
    }

    if(value === 'false') {
      value = false;
    }

    data = {
      [name]: value
    };

    this.props.store.SettingsStore.updateUserData(data);
  }

  handleToggle(e) {
    const proctorTypes = [...this.state.proctorTypes];

    if(e.target.checked) {
      proctorTypes.push(e.target.value);
    } else {
      const index = proctorTypes.indexOf(e.target.value);
      proctorTypes.splice(index, 1);
    }

    this.setState({
      proctorTypes
    }, function(){
      const data = {
        proctorTypes: this.state.proctorTypes
      }

      this.props.store.SettingsStore.updateUserData(data);
    });
  }

  handleSubmit() {
    const checked = document.querySelectorAll('.proctor-type-cbox:checked').length;

    if(checked < 1) {
      this.setState({
        proctorTypesInvalid: true
      }, function(){
        window.scrollTo(0, 0);
      });

      return false;
    } else {
      this.setState({
        proctorTypesInvalid: false
      });
    }

    this.props.store.SettingsStore.updateUserSettings(this.complete);
  }

  handlePhotoSubmit() {
    const data = {
      image:  this.state.attachment[0]
    }

    if(this.state.attachment.length > 0) {
      this.props.store.SettingsStore.updateProfilePhoto(data, this.complete('addPhoto', data), this);
    } else {
      this.props.store.SettingsStore.deleteProfilePhoto(this.complete('removePhoto'));
    }
  }

  resetPhoto() {
    this.setState({
      existingImage: this.state.oldImage,
      oldImage: []
    });
  }

  confirmPassword(e) {
    e.preventDefault();

    // Make sure confirm password matches
    let newPass = document.querySelector('#password-new');
    let confirm = document.querySelector('#password-confirm');

    if(newPass.value !== this.confirmPass.value) {
      confirm.setCustomValidity('Passwords do not match.');
    } else {
      confirm.setCustomValidity('');
    }

    checkValidity(e, this.handlePasswordSubmit);
  }

  handlePasswordSubmit() {
    let newPass = document.querySelector('#password-new');

    const data = {
      currentPassword: this.currentPass.value,
      newPassword: newPass.value,
      confirmPassword: this.confirmPass.value
    }

    this.props.store.SettingsStore.updatePassword(data, this.complete);

    // Reset the password form
    this.currentPass.value = '';
    newPass.value = '';
    this.confirmPass.value = '';

    // Make sure the now empty input fields aren't flagged as invalid
    const form = document.querySelector('form.submitted');

    if(form) {
      form.className = form.className.replace('submitted', '');
    }
  }

  handleSchedulingSubmit(e) {
    const { ScheduleStore, SessionStore } = this.props.store;

    e.preventDefault();

    if(this.scheduling.checked) {
      const data = {
        sid: SessionStore.userData.proctorAccountSid,
        title: SessionStore.profile.accountName || `${SessionStore.profile.firstName} ${SessionStore.profile.lastName}`,
        externalId: SessionStore.userData.proctorAccountSid
      }

      const callback = () => {
        SessionStore.showToaster(this.props.translation.scheduling.saved, 'success');
      }

      ScheduleStore.createScheduleAccount(data, callback);
    }
  }

  complete(type, data) {
    if(this.props.enrollment) {
      this.props.routing.history.push({
        pathname: '/'
      });
    }

    if(type === 'removePhoto') {
      this.props.store.SessionStore.showToaster(this.props.translation.photo_removed, 'success');

      this.setState({
        attachment: [],
        oldImage: [],
        existingImage: []
      });
    } else {
      this.props.store.SessionStore.showToaster(this.props.translation.settings_saved, 'success');

      this.setState({
        attachment: []
      });
    }
  }

  // This is annoying and not DRY, but because
  // of the way that LaunchDarkly’s FeatureFlag
  // component works, we need to duplicate some
  // code for the render functions to handle
  // SmarterScheduling enabled/disabled…
  renderScheduleTab() {
    const { translation } = this.props;
    const { ScheduleStore, SessionStore, SettingsStore } = this.props.store;
    const { userSettings } = SettingsStore;

    return (
      <div>
        <Tabs
          onSelect={this.handleTabs}
        >
          <TabList className="tabs-enabled">
            <Tab>{translation.tabs.general}</Tab>
            <Tab>{translation.tabs.photo}</Tab>
            <Tab>{translation.tabs.password}</Tab>
            <Tab>{translation.tabs.scheduling}</Tab>
          </TabList>

          <TabPanel>
            <form onSubmit={(e) => checkValidity(e, this.handleSubmit)} noValidate>
              <fieldset>
                <ul className="fields">
                  <li className="field--half inp-hidden">
                    <label className="lbl-required" htmlFor="profile-fname">{translation.name.first}</label>
                    <span className="faux-input">{userSettings.firstName}</span>
                  </li>
                  <li className="field--half inp-hidden">
                    <label className="lbl-required" htmlFor="profile-lname">{translation.name.last}</label>
                    <span className="faux-input">{userSettings.lastName}</span>
                  </li>
                  <li className="inp-hidden">
                    <label className="lbl-required" htmlFor="profile-email">{translation.email}</label>
                    <span className="faux-input">{userSettings.email}</span>
                  </li>
                  <li>
                    <input
                      type="checkbox"
                      id="written"
                      className="switch-input"
                      ref={(input) => this.written = input}
                      value={true}
                      defaultChecked={userSettings.acceptWrittenExams}
                      onChange={(e) => this.handleInput(e, 'acceptWrittenExams')}
                    />

                    <label
                      className="switch-label"
                      htmlFor="written"
                    >
                      <span className="meta">{translation.written.label}</span>
                    </label>

                    <label
                      className="switch-label--alt"
                      htmlFor="written"
                      aria-describedby="written-tooltip"
                    >
                      {translation.written.label}

                      <div className="tooltip">
                        <span className="tooltip__label">(?)</span>
                        <div id="written-tooltip" className="tooltip__body" role="tooltip">
                          {translation.written.helper}
                        </div>
                      </div>
                    </label>
                  </li>
                  {userSettings.verifiedBy &&
                    <li>
                      <input
                        type="checkbox"
                        id="activate"
                        className="switch-input"
                        ref={(input) => this.active = input}
                        value={true}
                        defaultChecked={userSettings.active}
                        onChange={(e) => this.handleInput(e, 'active')}
                      />

                      <label
                        className="switch-label"
                        htmlFor="activate"
                      >
                        <span className="meta">{translation.activate.label}</span>
                      </label>

                      <label
                        className="switch-label--alt"
                        htmlFor="activate"
                        aria-describedby="activate-tooltip"
                      >
                        {translation.activate.label}

                        <div className="tooltip">
                          <span className="tooltip__label">(?)</span>
                          <div id="activate-tooltip" className="tooltip__body" role="tooltip">
                            {translation.activate.helper}
                          </div>
                        </div>
                      </label>
                    </li>
                  }
                </ul>
              </fieldset>

              <fieldset>
                <h4 className="form-heading">
                  {translation.proctor_type.heading}
                  <div className="tooltip">
                    <span className="tooltip__label">(?)</span>
                    <div id="proctor-type-tooltip" className="tooltip__body" role="tooltip">{translation.proctor_type.tooltip}</div>
                  </div>
                </h4>

                {this.state.proctorTypesInvalid &&
                  <span className="note note--prominent note--error">
                    {translation.proctor_type.none_selected}
                  </span>
                }

                {SessionStore.proctorTypeList.map(
                  (key, i) => {
                    if(
                      (
                        userSettings.type === 'individual-proctor' &&
                        key.sid !== config.testingCenterSid
                      ) || (
                        userSettings.type !== 'individual-proctor' &&
                        key.sid === config.testingCenterSid
                      )
                    ) {
                      return (
                        <div className="form-subgroup" key={i}>
                          <strong className="form-subheading">{key.title}</strong>

                          <ul className="switch-list">
                            {key.subCategories.filter(function(obj){
                              return obj.allowSelfSelection;
                            }).map(
                              (subKey, j) => {
                                if(
                                  subKey.sid !== config.testingAdministratorSid &&
                                  subKey.sid !== config.generalPublicSid
                                ) {
                                  return (
                                    <li key={j}>
                                      <label htmlFor={`register-type${i}-${j}`}>
                                        {subKey.title}
                                      </label>

                                      <input
                                        type="checkbox"
                                        id={`register-type${i}-${j}`}
                                        className="switch-input proctor-type-cbox"
                                        value={subKey.sid}
                                        onChange={(e) => {this.handleToggle(e)}}
                                        defaultChecked={this.state.proctorTypes.indexOf(subKey.sid) > -1}
                                        disabled
                                      />
                                      <label className="switch-label" htmlFor={`register-type${i}-${j}`}><span className="meta">{subKey.title}</span></label>
                                    </li>
                                  )
                                }

                                return null;
                              }
                            )}
                          </ul>
                        </div>
                      )
                    }

                    return null;
                  }
                )}
              </fieldset>

              <button className="actions__btn actions__btn--primary" type="submit">{translation.save}</button>
            </form>
          </TabPanel>

          <TabPanel>
            <form className="block-form block-form--brief" onSubmit={(e) => checkValidity(e, this.handlePhotoSubmit)} noValidate>
              <fieldset>
                <PhotoUpload
                  attachment={this.state.attachment}
                  parent={this}
                  existingImage={this.state.existingImage}
                  {...this.props}
                />
              </fieldset>

              <div className="actions">
                <button
                  className="actions__btn actions__btn--primary"
                  type="submit"
                  disabled={this.state.attachment.length === 0 && this.state.oldImage.length === 0}
                >
                  {translation.save}
                </button>

                {this.state.oldImage.length > 0 && this.state.existingImage.length === 0 &&
                  <button
                    className="btn--link"
                    onClick={this.resetPhoto}
                    type="button"
                  >
                    {translation.cancel}
                  </button>
                }
              </div>
            </form>
          </TabPanel>

          <TabPanel>
            <form onSubmit={(e) => this.confirmPassword(e)} noValidate>
              <fieldset>
                <ul className="fields">
                  <li>
                    <label className="lbl-required" htmlFor="password-current">
                      {translation.current_password}
                    </label>

                    <input
                      id="password-current"
                      type="password"
                      ref={(input) => {this.currentPass = input}}
                      required
                      aria-required="true"
                    />
                  </li>
                  <li>
                    <label className="lbl-required" htmlFor="password-new">
                      {translation.new_password}
                    </label>

                    <Password
                      id="password-new"
                      parent={this}
                      name="password"
                      {...this.props}
                    />
                  </li>
                  <li>
                    <label className="lbl-required" htmlFor="password-confirm">
                      {translation.confirm_password}
                    </label>

                    <input
                      id="password-confirm"
                      type="password"
                      ref={(input) => {this.confirmPass = input}}
                      required
                      aria-required="true"
                    />
                  </li>
                </ul>
              </fieldset>

              <button className="actions__btn actions__btn--primary" type="submit">{translation.save}</button>
            </form>
          </TabPanel>

          <TabPanel>
            <form onSubmit={(e) => this.handleSchedulingSubmit(e)} noValidate>
              <fieldset>
                <ul className="fields">
                  <li>
                    <label
                      className="switch-label--alt"
                      htmlFor="activate"
                    >
                      {translation.scheduling.label}

                      <div className="tooltip">
                        <span className="tooltip__label">(?)</span>
                        <div id="activate-tooltip" className="tooltip__body" role="tooltip">
                          {translation.scheduling.helper}
                        </div>
                      </div>
                    </label>

                    <input
                      type="checkbox"
                      id="activate"
                      className="switch-input"
                      ref={(input) => this.scheduling = input}
                      value={true}
                      defaultChecked={ScheduleStore.scheduleAccountEnabled}
                      disabled={ScheduleStore.scheduleAccountEnabled}
                    />

                    <label
                      className="switch-label"
                      htmlFor="activate"
                      aria-describedby="activate-tooltip"
                    >
                      <span className="meta">{translation.scheduling.label}</span>
                    </label>
                  </li>
                </ul>
              </fieldset>

              <button className="actions__btn actions__btn--primary" type="submit">{translation.save}</button>
            </form>
          </TabPanel>
        </Tabs>
      </div>
    )
  }

  renderNoScheduleTab() {
    const { translation } = this.props;
    const { SessionStore, SettingsStore } = this.props.store;
    const { userSettings } = SettingsStore;

    return (
      <div>
        <Tabs
          onSelect={this.handleTabs}
        >
          <TabList className="tabs-enabled">
            <Tab>{translation.tabs.general}</Tab>
            <Tab>{translation.tabs.photo}</Tab>
            <Tab>{translation.tabs.password}</Tab>
          </TabList>

          <TabPanel>
            <form onSubmit={(e) => checkValidity(e, this.handleSubmit)} noValidate>
              <fieldset>
                <ul className="fields">
                  <li className="field--half inp-hidden">
                    <label className="lbl-required" htmlFor="profile-fname">{translation.name.first}</label>
                    <span className="faux-input">{userSettings.firstName}</span>
                  </li>
                  <li className="field--half inp-hidden">
                    <label className="lbl-required" htmlFor="profile-lname">{translation.name.last}</label>
                    <span className="faux-input">{userSettings.lastName}</span>
                  </li>
                  <li className="inp-hidden">
                    <label className="lbl-required" htmlFor="profile-email">{translation.email}</label>
                    <span className="faux-input">{userSettings.email}</span>
                  </li>
                  <li>
                    <input
                      type="checkbox"
                      id="written"
                      className="switch-input"
                      ref={(input) => this.written = input}
                      value={true}
                      defaultChecked={userSettings.acceptWrittenExams}
                      onChange={(e) => this.handleInput(e, 'acceptWrittenExams')}
                    />

                    <label
                      className="switch-label"
                      htmlFor="written"
                    >
                      <span className="meta">{translation.written.label}</span>
                    </label>

                    <label
                      className="switch-label--alt"
                      htmlFor="written"
                      aria-describedby="written-tooltip"
                    >
                      {translation.written.label}

                      <div className="tooltip">
                        <span className="tooltip__label">(?)</span>
                        <div id="written-tooltip" className="tooltip__body" role="tooltip">
                          {translation.written.helper}
                        </div>
                      </div>
                    </label>
                  </li>
                  {userSettings.verifiedBy &&
                    <li>
                      <input
                        type="checkbox"
                        id="activate"
                        className="switch-input"
                        ref={(input) => this.active = input}
                        value={true}
                        defaultChecked={userSettings.active}
                        onChange={(e) => this.handleInput(e, 'active')}
                      />

                      <label
                        className="switch-label"
                        htmlFor="activate"
                      >
                        <span className="meta">{translation.activate.label}</span>
                      </label>

                      <label
                        className="switch-label--alt"
                        htmlFor="activate"
                        aria-describedby="activate-tooltip"
                      >
                        {translation.activate.label}

                        <div className="tooltip">
                          <span className="tooltip__label">(?)</span>
                          <div id="activate-tooltip" className="tooltip__body" role="tooltip">
                            {translation.activate.helper}
                          </div>
                        </div>
                      </label>
                    </li>
                  }
                </ul>
              </fieldset>

              <fieldset>
                <h4 className="form-heading">
                  {translation.proctor_type.heading}
                  <div className="tooltip">
                    <span className="tooltip__label">(?)</span>
                    <div id="proctor-type-tooltip" className="tooltip__body" role="tooltip">{translation.proctor_type.tooltip}</div>
                  </div>
                </h4>

                {this.state.proctorTypesInvalid &&
                  <span className="note note--prominent note--error">
                    {translation.proctor_type.none_selected}
                  </span>
                }

                {SessionStore.proctorTypeList.map(
                  (key, i) => {
                    if(
                      (
                        userSettings.type === 'individual-proctor' &&
                        key.sid !== config.testingCenterSid
                      ) || (
                        userSettings.type !== 'individual-proctor' &&
                        key.sid === config.testingCenterSid
                      )
                    ) {
                      return (
                        <div className="form-subgroup" key={i}>
                          <strong className="form-subheading">{key.title}</strong>

                          <ul className="switch-list">
                            {key.subCategories.filter(function(obj){
                              return obj.allowSelfSelection;
                            }).map(
                              (subKey, j) => {
                                if(
                                  subKey.sid !== config.testingAdministratorSid &&
                                  subKey.sid !== config.generalPublicSid
                                ) {
                                  return (
                                    <li key={j}>
                                      <label htmlFor={`register-type${i}-${j}`}>
                                        {subKey.title}
                                      </label>

                                      <input
                                        type="checkbox"
                                        id={`register-type${i}-${j}`}
                                        className="switch-input proctor-type-cbox"
                                        value={subKey.sid}
                                        onChange={(e) => {this.handleToggle(e)}}
                                        defaultChecked={this.state.proctorTypes.indexOf(subKey.sid) > -1}
                                        disabled
                                      />
                                      <label className="switch-label" htmlFor={`register-type${i}-${j}`}><span className="meta">{subKey.title}</span></label>
                                    </li>
                                  )
                                }

                                return null;
                              }
                            )}
                          </ul>
                        </div>
                      )
                    }

                    return null;
                  }
                )}
              </fieldset>

              <button className="actions__btn actions__btn--primary" type="submit">{translation.save}</button>
            </form>
          </TabPanel>

          <TabPanel>
            <form className="block-form block-form--brief" onSubmit={(e) => checkValidity(e, this.handlePhotoSubmit)} noValidate>
              <fieldset>
                <PhotoUpload
                  attachment={this.state.attachment}
                  parent={this}
                  existingImage={this.state.existingImage}
                  {...this.props}
                />
              </fieldset>

              <div className="actions">
                <button
                  className="actions__btn actions__btn--primary"
                  type="submit"
                  disabled={this.state.attachment.length === 0 && this.state.oldImage.length === 0}
                >
                  {translation.save}
                </button>

                {this.state.oldImage.length > 0 && this.state.existingImage.length === 0 &&
                  <button
                    className="btn--link"
                    onClick={this.resetPhoto}
                    type="button"
                  >
                    {translation.cancel}
                  </button>
                }
              </div>
            </form>
          </TabPanel>

          <TabPanel>
            <form onSubmit={(e) => this.confirmPassword(e)} noValidate>
              <fieldset>
                <ul className="fields">
                  <li>
                    <label className="lbl-required" htmlFor="password-current">
                      {translation.current_password}
                    </label>

                    <input
                      id="password-current"
                      type="password"
                      ref={(input) => {this.currentPass = input}}
                      required
                      aria-required="true"
                    />
                  </li>
                  <li>
                    <label className="lbl-required" htmlFor="password-new">
                      {translation.new_password}
                    </label>

                    <Password
                      id="password-new"
                      parent={this}
                      name="password"
                      {...this.props}
                    />
                  </li>
                  <li>
                    <label className="lbl-required" htmlFor="password-confirm">
                      {translation.confirm_password}
                    </label>

                    <input
                      id="password-confirm"
                      type="password"
                      ref={(input) => {this.confirmPass = input}}
                      required
                      aria-required="true"
                    />
                  </li>
                </ul>
              </fieldset>

              <button className="actions__btn actions__btn--primary" type="submit">{translation.save}</button>
            </form>
          </TabPanel>
        </Tabs>
      </div>
    )
  }

  render() {
    const { SessionStore } = this.props.store;

    // Don’t use the default tab styles
    Tabs.setUseDefaultStyles(false);

    if(!SessionStore.loading) {
      return (
        <div className="wrap block-form block-form--brief">
          <FeatureFlag
            flagKey="proctor-schedules"
            renderFeatureCallback={this.renderScheduleTab}
            renderDefaultCallback={this.renderNoScheduleTab}
          />
        </div>
      )
    }

    return null;
  }
})

export default translate('UserSettings')(UserSettings);



// WEBPACK FOOTER //
// ./src/app/components/Settings/UserSettings.js